import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { withStyles, Paper } from '@material-ui/core';
import { hasPermission, parseURL, BackButton } from '../../../../sc-utilities';
import * as actions from '../../store/billingAccountActions';
import LoadingDialog from '../LoadingDialog'
import SoftwareLicenseForm from './SoftwareLicenseForm'
import History from '../../../../../History';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        minHeight: '500px',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    }
});

const SoftwareLicenseUpdate = props => {
    const { classes, softwareLicenses, permissions, onFetchSoftwareLicense, onUpdateSoftwareLicense, translations, activeCustomer, listLicensePrototypes } = props;
    const [editData, setEditData] = useState({ licensePrototypes: [], softwareLicense: null, loadingData: true })
    let { LicenseID, AccountID } = parseURL(window.location.search)


    useEffect(() => {
        const fetchData = async () => {
            let data = await onFetchSoftwareLicense({ SoftwareLicenseID: LicenseID, ActiveCustomerID: activeCustomer, ActiveAccountID: AccountID });
            setEditData((previousState) => { return {...previousState, loadingData: false, softwareLicense: data}})
        }
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (softwareLicenses.loaded) {
            const fetchData = async () => {
                let data = await listLicensePrototypes({ ActiveCustomerID: activeCustomer, ActiveAccountID: AccountID })
                setEditData({ softwareLicense: softwareLicenses.loaded, loadingData: false, licensePrototypes: data })
            }
            fetchData();

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [softwareLicenses.loaded])


    const submitHandler = async data => {
        data['ActiveAccountID'] = AccountID
        data['SoftwareLicenseID'] = editData.softwareLicense.LicenseID;
        await onUpdateSoftwareLicense({ ...data, ActiveCustomerID: activeCustomer });
        History.goBack();
    };

    let statuses = [{ value: 'active', displayValue: translations["active"] || 'Active' }, { value: 'inactive', displayValue: translations["inactive"] || 'Inactive' }]

    let initialValues = {
        Name: editData.softwareLicense && editData.softwareLicense.Name ? editData.softwareLicense.Name : '',
        SecretKey: editData.softwareLicense && editData.softwareLicense.SecretKey ? editData.softwareLicense.SecretKey : '',
        Status: editData.softwareLicense && editData.softwareLicense.Status ? editData.softwareLicense.Status : 'inactive',
        ExpiresAt: editData.softwareLicense && editData.softwareLicense.ExpiresAt ? editData.softwareLicense.ExpiresAt : null,
        LicensePrototypeID: editData.softwareLicense && editData.softwareLicense.LicensePrototypeID ? editData.softwareLicense.LicensePrototypeID : null,
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required('Required'),
            SecretKey: Yup.string().required('Required'),
            Status: Yup.string().required('Required'),
            ExpiresAt: Yup.date()
                .notRequired()
                .nullable(true),
            LicensePrototypeID: Yup.string().required('Required')

        },
        FormTitle: translations["update_software_license"] || `Update software license`,
        ButtonSubmit: hasPermission(permissions, 'software_license_update') ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null,
    };



    return editData.loadingData ? <LoadingDialog /> :
        <Paper className={classes.root}>
            {BackButton(translations, classes.customTooltip)}
            <SoftwareLicenseForm
                initialValues={initialValues}
                translations={translations}
                formSettings={formSettings}
                handleSubmit={submitHandler}
                statuses={statuses}
                licensePrototypes={editData.licensePrototypes}
                loading={softwareLicenses.updating ? softwareLicenses.updating : false}
                editForm={true}
            ></SoftwareLicenseForm>
        </Paper>
}


const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
        softwareLicenses: state.billing.accounts ? state.billing.accounts.softwareLicenses : null,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        listLicensePrototypes: id => dispatch(actions.listLicensePrototypes(id)),
        onFetchSoftwareLicense: params => dispatch(actions.onFetchSoftwareLicense(params)),
        onUpdateSoftwareLicense: params => dispatch(actions.onUpdateSoftwareLicense(params)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SoftwareLicenseUpdate));